import axios from 'axios';
import config from '../config';
import { toast } from 'react-toastify';

const axiosInstance = axios.create({
    baseURL: config.api.API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 100000,
    withCredentials: true,
});

axiosInstance.interceptors.request.use(
    config => {
        // Filtra valores vazios ou nulos antes de serem enviados ao backend
        if (config.headers['Content-Type'] !== 'multipart/form-data' && typeof config.data === 'object') {
            const filteredValues: any = {};
            for (const [key, value] of Object.entries(config.data)) {
                if (value !== '') {
                    filteredValues[key] = value;
                }
            }
            config.data = filteredValues;
        }

        return config;
    },
    error => Promise.reject(error),
);

axiosInstance.interceptors.response.use(
    response => response,
    async error => {
        // Exibe as mensagens de erro do backend para o usuário
        if (error.response) {
            const message = error.response.data?.message;
            if (message) {
                if (Array.isArray(message)) {
                    message.forEach((value: string) => {
                        toast.error(value);
                    });
                } else {
                    toast.error(message);
                }
            }

            // Se a sessão expirou, redirecionar para login
            if (error.response.status === 401) {
                window.location.replace('/logout');
            }
        } else if (error.message) {
            toast.error(error.message);
        }

        return Promise.reject(error);
    },
);

export default axiosInstance;
